<template>
    <div class="installt">
        <div class="intext">品牌列表</div>
        <div class="addpopers">
            <!-- <div class="addpoper" @click="openDialog">
                <div> <el-icon :size="24" color="#fff">
                        <Plus style=" margin-right: 8px" />
                    </el-icon></div>
                <div style="height: 24px;">批量上架</div>

            </div> -->
            <div class="addpoper" @click="goodadd">
                <div> <el-icon :size="24" color="#fff">
                        <Plus style=" margin-right: 8px" />
                    </el-icon></div>
                <div style="height: 24px;">添加品牌</div>

            </div>
        </div>

    </div>
    <div class="viplist">
        <Noshu :disabled="loading" :lengths="infolists.length"></Noshu>

        <div class="pagechoose">

            显示结果：

            <div class="pagees">

                <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

            </div>

        </div>
        <div class="vipt">
            <div class="screen">
                <el-cascader v-model="value" :options="options" placeholder="类型筛选:" @change="handleChange" />
            </div>
            <div class="search">
                <div style="width: 24px;height: 24px;text-align: center;">
                    <img style="width: 100%;height: 100%;" src="../../assets/secree.png" alt="">
                </div>
                <div>
                    <input type="text" placeholder="规格类型/规格ID" v-model="keyseach" @keyup.enter="wordkey">
                </div>
            </div>

        </div>
        <div class="vipporpe" v-loading="loading">
            <table>
                <thead>
                    <tr>

                        <th style="width: 170px;">品牌名称</th>
                        <th style="width: 173px;">品牌id</th>
                        <th style="width: 173px;">品牌首字母</th>
                        <th style="width: 183px;">排序</th>
                        <!-- <th style="width: 160px;">关联产品（个）</th> -->

                        <th>操作</th>


                        <!-- <th class="states" style="width: 80px;">操作</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in infolists" :key="index" style="cursor: pointer;">

                        <td>
                            <div class="stroeh">
                                <div class="header">
                                    <img :src="images(item.brandLogo)" alt="">
                                </div>
                                <div class="storename">
                                    <div class="storepname" v-html="item.brandName"></div>
                                    <!-- <div class="stid" v-html="'ID:' + item.productId"></div> -->
                                </div>
                            </div>
                        </td>
                        <td>
                            {{ item.id || '暂无' }}
                        </td>
                        <td>
                            {{ item.binitial || '暂无' }}
                        </td>
                        <td>
                            {{ item.brandOrder }}
                        </td>


                        <td @click.stop>
                            <div class="operate">
                                <!-- <div @click="gomessage(item, 1)">查看规格</div>
                                <div @click="gomessage(item, 2)">查看参数</div> -->
                                <div @click="namechange(item)">编辑</div>
                                <div style="margin-left: 20px;" @click="spec(item.id)">删除</div>

                            </div>

                        </td>


                    </tr>
                </tbody>
            </table>

            <div style=" height: 70px;"></div>



        </div>
        <div class="example-pagination-block" :style="{ 'display': wordKey.length >= 1 ? 'none' : '' }">
            <el-pagination background v-model:current-page="pageCount" layout="prev, pager, next" :pager-count="5"
                :page-count="total" @current-change="changepige" :disabled="loading" />
        </div>
        <div class="example-pagination-iskey" :style="{ 'display': wordKey.length >= 1 ? '' : 'none' }">
            <el-pagination background v-model:current-page="pageCount" layout="prev, pager, next" :pager-count="5"
                :page-count="9999999" @current-change="changepige" :disabled="loading" />
        </div>
    </div>
    <el-dialog v-model="centerDialogVisible" title="请完善品牌信息" width="500" align-center>
        <div class="addmy">
            <div>

                <div class="libaoname" style="margin-top: 0;">
                    <div class="libaonams">品牌名称</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入品牌名称" v-model="pingpaix.storeBrand.brandName">
                    </div>

                </div>
                <div class="libaoname">
                    <div class="libaonams">品牌首字母</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入品牌首字母" v-model="pingpaix.storeBrand.binitial">
                    </div>

                </div>
                <div class="libaoname">
                    <div class="libaonams">排序</div>
                    <div class="liname">
                        <input type="text" placeholder="排序" v-model="pingpaix.storeBrand.brandOrder">
                    </div>

                </div>
                <div class="libaoname">
                    <div class="libaonams">品牌故事</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入内容" v-model="pingpaix.storeBrand.brandStory">
                    </div>

                </div>
                <div class="libaoname">
                    <div class="libaonams">品牌LOGO</div>
                    <el-upload class="avatar-uploader" :action="isdevelopment" :show-file-list="false"
                        :data="{ scopeType: 'brandImg' }" :headers="{ X_access_token: tokenup }"
                        :on-progress="uploadVideoProcess" name="files" :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="pingpaix.storeBrand.brandLogo" :src="pingpaix.storeBrand.brandLogo" class="avatar" />
                        <el-icon v-else class="avatar-uploader-icon">
                            <Plus />
                        </el-icon>
                    </el-upload>
                    &nbsp; &nbsp;  <span  v-if="progressFlag"  > {{ loadProgress }}% </span>
                    <!-- <el-progress></el-progress> -->

                </div>

            </div>


        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="tianclose">取消</el-button>
                <el-button type="primary" @click="specTypeput">
                    提交
                </el-button>
            </div>
        </template>
    </el-dialog>

</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
// import Pagintion from '@/components/Pagination.vue'
import api from '@/api/api'
import Noshu from '@/components/Noshu.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import images from '@/utils/images';
let loading = ref(false)
let token = localStorage.getItem('token')
// console.log('token',token)
const tokenup = ref(String(token));
let filesimg = ref({
    scopeType: 'brandImg'
})
let wordKey = ref('')
let keyseach = ref('')
let pageCount = ref(1)
const router = useRouter()
const infolists = ref([])
let startTime = ref('')
let endTime = ref('')
let total = ref(1)
let screenType = ref('0')
const value = ref([])
let sort = ref(false)

const options = reactive([
 
    {
        value: '1',
        label: '品牌ID',
    },
    {
        value: '2',
        label: '品牌名称',
    }
])

const handleAvatarSuccess = (response, uploadFile) => {
    console.log('uploadFile', uploadFile, response)
    if (response) {
        pingpaix.value.storeBrand.brandLogo = response.data[0].data
    }
}
let progressFlag = ref(false)
let loadProgress = ref(0)
const uploadVideoProcess = (event, file, fileList) => {
    progressFlag.value = true; // 显示进度条
    loadProgress.value = parseInt(event.percent); // 动态获取文件上传进度
    console.log( '显示进度条', loadProgress.value,event, file, fileList)
    if (loadProgress >= 100) {
        loadProgress = 100
        setTimeout(() => { progressFlag = false }, 1000) // 一秒后关闭进度条
    }

}
const tianclose = () => {
    centerDialogVisible.value = false
    loadProgress.value = 0

}
const beforeAvatarUpload = (rawFile) => {
    console.log('rawFile', rawFile)
    if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png') {
        ElMessage.error('图片只能为png和jpg格式')
        return false
    } else if (rawFile.size / 1024 / 1024 > 5) {
        ElMessage.error('图片不能大于 5MB!')
        return false
    }
    return true
}
const specTypeput = async () => {




    let data = pingpaix._rawValue
    console.log('specTypeput', data, pingpaix)
    if (data.storeBrand.brandLogo.length < 1 || data.storeBrand.brandName.length < 1 || data.storeBrand.binitial.length < 1 || data.storeBrand.brandOrder.length < 1) {
        ElMessage.error('请完善信息!')

    } else {
        const res = await api.pbrand(data)

        if (res.success) {
            ElMessage({
                type: 'success',
                message: `保存成功`,
                onClose: () => {
                    centerDialogVisible.value = false
                    loadProgress.value = 0
                    infoList()
                }
            })
        } else {
            ElMessage.error('保存失败!')
        }
    }

}

let pageSize = ref(7)

const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    infoList()
}

const infoList = async () => {
    loading.value = true

    try {
        let data = {
            screenType: value.value[0],
            pageCount: pageCount.value,
            pageSize: pageSize.value,
            storeId: '77',
            wordKey: wordKey.value
        }
        console.log(data)

        const res = await api.brandList(data)
        console.log(res)
        if (res.code == 401) {
            ElMessageBox.alert('登录已过期请重新登入！', '', {

                confirmButtonText: 'OK',
                callback: (action) => {
                    router.push({
                        path: '/login'
                    })
                },
            })
            // router.push('login')
        }
        if (res.data) {
            infolists.value = res.data.storeBrands

            total.value = (Math.ceil(res.data.total / pageSize.value))
            loading.value = false
            // console.log(res.data.members)
            // console.log(res.data.total)
        } else {
            loading.value = false

            infolists.value = []
        }

    } catch (error) {
        console.log(error)
    }
}
let isdevelopment = ref()

onMounted(() => {
    console.log('process.env.NODE_ENV', process.env.NODE_ENV)
    isdevelopment.value = process.env.NODE_ENV === 'development' ? '/api/commodity/productFileUpload' : 'http://120.31.134.56:7878/commodity/productFileUpload'
    pageCount.value = 1
    infoList()
})
const wordkey = () => {
    wordKey.value = keyseach.value

    pageCount.value = 1
    infoList()
}
let centerDialogVisible = ref(false)
let pingpaix = ref({})
const goodadd = () => {
    pingpaix.value = {
        'operateMode': 1,
        "storeBrand": {
            "binitial": "",
            "brandDesc": "",
            "brandLogo": "",
            "brandName": "",
            "brandOrder": 0,
            "brandStatus": 1,
            "brandStory": "",
            // "id": 0,
            "modifiedTime": "",
            "storeId": 77
        }
    }
    centerDialogVisible.value = true
}
const namechange = (item) => {
    // console.log(item)
    pingpaix.value = {
        'operateMode': 2,
        "storeBrand": {
            "binitial": item.binitial,
            "brandDesc": item.brandDesc,
            "brandLogo": item.brandLogo,
            "brandName": item.brandName,
            "brandOrder": item.brandOrder,
            "brandStatus": 1,
            "brandStory": item.brandStory,
            "id": item.id,
            "modifiedTime": item.modifiedTime,
            "storeId": item.storeId
        }
    }
    console.log('namechange', item, pingpaix)

    centerDialogVisible.value = true
}
let pids = ref([])
const spec = (id) => {
    ElMessageBox.confirm('是否删除该规格？')
        .then(() => {
            detspec(id)
        })
        .catch(() => {
            // catch error
        })
}
const detspec = async (id) => {
    let data = {
        brandId: id
    }
    const res = await api.dbrand(data)
    if (res.success) {
        ElMessage({
            message: '删除成功',
            type: 'success',
            onClose: () => {
                infoList()
            }
        })
    } else {
        ElMessage({
            message: '删除失败',
            type: 'warning',

        })
    }

}

const handleChange = (value) => {
    console.log(value)
    screenType.value = value[0]
}
const gomessage = (item, type) => {
    router.push({
        path: '/home/standard/standerdmsg',
        query: {
            id: item.id,
            storeId: item.storeId,
            name: item.typeName,
            type: type
        }
    })

}





//跳转页面
const changepige = (val) => {

    pageCount.value = val
    infoList()

}

</script>

<style lang="scss" scoped>
::v-deep .avatar-uploader {
    .el-upload {
        width: 90px;
        height: 90px;
        //   border: 1px dashed #8c939d;
        border: 1px dashed #8c939d;
        // border-color: #8c939d;

        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        transition: var(--el-transition-duration-fast);

        img {
            width: 100%;
            // height: 100%;
        }
    }

    // img{
    //     width: 100%;
    //     height: 100%;
    // }

    .el-upload:hover {
        border-color: #8c939d;
    }
}




.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
}

::v-deep .el-checkbox {


    // height: 100%;

    .el-checkbox__input {
        height: 20px;

        .el-checkbox__inner {
            width: 20px;
            height: 20px;
            border-radius: 10px;
        }

        .el-checkbox__inner {
            &::after {
                top: 4px;
                left: 8px;
            }

        }
    }
}

::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #FAFAFA;
    --el-input-border-color: transparent;
    cursor: pointer;

    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }

}

::v-deep .example-pagination-block {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    // .el-pager{
    //     display: none;
    // }

    .is-active {
        background-color: #FAFAFA !important;
        color: #1787FF !important;
        border-radius: 8px;
    }

}

::v-deep .example-pagination-iskey {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .el-pager {
        display: none;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }
}


.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 32px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpopers {
        display: flex;

        .addpoper {
            width: 132px;
            height: 48px;
            background: rgba(63, 140, 255);
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            border-radius: 8px;
            color: #FFFFFF;

            padding-left: 16px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-left: 33px;
        }
    }

}

.viplist {
    position: relative;
    margin-top: 25px;
    height: calc(100% - 85px);
    min-width: 1166px;
    // min-height: 662px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;

    .pagechoose {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 70px;
        padding-left: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .pagees {
            width: 71px;
            height: 40px;
            border: 1px solid #EEEFF2;
            border-radius: 8px;
            padding: 8px 0 0 0px;
            box-sizing: border-box;

            input {
                width: 80%;


            }
        }
    }

    .vipporpe {
        width: 100%;
        // padding-left: 15px;
        box-sizing: border-box;



        table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            padding: 0;
            margin: 0;

            thead {
                width: 100%;
                height: 46px;
                text-align: left;
                display: table-header-group;
                font-size: 14px;
                font-weight: 400;
                color: #4D585F;
                border-bottom: 1px solid #EEEFF2;

                th {
                    vertical-align: middle;
                }

                th:first-child {
                    padding-left: 15px;

                }

                .states {
                    text-align: center;
                }
            }

            tbody {
                tr {

                    height: 71px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #000000;
                    border-bottom: 1px solid #EEEFF2;

                    .stroeh {
                        display: flex;

                        .header {
                            width: 56px;
                            height: 56px;
                            background-color: #718096;
                            border-radius: 8px;
                            margin-right: 24px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .storename {
                            width: 200px;
                            font-size: 16px;

                            font-weight: 400;
                            color: #111827;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;

                            .storepname {
                                overflow: hidden;
                                /* 隐藏溢出的文本 */
                                text-overflow: ellipsis;
                                /* 添加省略号 */
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                /* 设置要截断的行数 */
                                -webkit-box-orient: vertical;
                            }

                            .stid {
                                font-size: 14px;
                                font-family: HelveticaNeue;
                                color: #718096;
                            }
                        }

                    }


                    td:first-child {
                        padding-left: 15px;

                    }

                    td:last-child {
                        width: 66px;
                        padding-right: 9px;

                        .operate {
                            width: 200px;

                            color: #1787FF;
                            font-weight: 400;
                            font-size: 12px;
                            display: flex;
                            // justify-content: space-between;


                        }
                    }

                    td {

                        vertical-align: middle;

                        .statea {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .state {
                                width: 66px;
                                height: 36px;
                                background: #EBF3FF;
                                border-radius: 4px;
                                text-align: center;
                                line-height: 36px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #1787FF;
                            }

                            .state2 {
                                width: 66px;
                                height: 36px;
                                background: rgb(252, 241, 231);
                                border-radius: 4px;
                                text-align: center;
                                line-height: 36px;
                                font-size: 14px;
                                font-weight: 400;
                                color: rgb(243, 182, 133);
                            }
                        }


                    }


                }

                tr:hover {
                    background-color: #f3f3f3;
                }
            }

        }
    }

    .vipt {
        padding-top: 17px;
        margin-left: 15px;
        display: flex;

        .screen {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;
            margin-right: 24px;
        }

        .search {
            width: 412px;
            height: 48px;
            margin-right: 14px;
            background: #FAFAFA;
            // box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
            border-radius: 8px;
            display: flex;
            align-items: center;
            padding-left: 20px;
            box-sizing: border-box;

            input {
                width: 300px;
                border: none;
                outline: none;
                font-size: 16px;
                background: #FAFAFA;

            }

            ::placeholder {
                font-weight: 400;
                font-size: 14px;
                color: #7D8592;
            }

        }

        .calendar {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;



        }

        .exdown {
            width: 101px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;
            margin-left: 31px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #718096;
            cursor: pointer;


            img {
                width: 17px;
                height: 21px;
            }
        }

    }
}

.dialog {
    position: relative;
    width: 500px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
        padding: 23px 36px 0 35px;
    }

    .exchooses {
        padding: 23px 36px 0 35px;
        height: 400px;
        overflow: auto;

        .exchoosee {
            display: flex;
            height: 38px;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #111827;
            align-items: center;
            margin-top: 13px;
        }
    }

    .downex {
        .dowm {
            width: 121px;
            height: 51px;
            background: #3686FF;
            border-radius: 8px;
            text-align: center;
            line-height: 51px;
            font-size: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }

        display: flex;
        align-items: center;
        justify-content: center;
        width: 500px;
        height: 120px;
        background: #F2F8FC;

    }

}

.addmy {
    // width: 465px;
    // height: 443px;
    background: #FFFFFF;


    font-size: 16px;
    color: #111827;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;

    }


    .libaoname {
        margin-top: 17px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        font-size: 14px;

        .libaonams {
            width: 100px;
        }

        .liname {
            width: 300px;
            height: 36px;
            background: #FAFAFA;
            margin-top: 6px;

            input {
                font-size: 14px;
                height: 36px;

            }
        }
    }

    .islibao {
        width: 100%;
        height: 101px;
        border-top: 1px solid #EEEFF2;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-top: 55px;

        .quxiao {
            width: 108px;
            height: 48px;
            border: 1px solid #979797;
            text-align: center;
            line-height: 48px;
            border-radius: 8px;
            cursor: pointer;

        }

        .queren {
            background: #79AFFF;
            color: #FFFFFF;
            border: 1px solid transparent;

        }
    }
}
</style>